import ActionTypes from '../constants';

const initialState = {
    vehicleMakers: {},
    vehicleMaker: {},
    newVehicleMake: {}
    // loading: false,
};

const vehicleMakerReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETVEHICLEMAKERSUCCESS:
            return {
                ...state,
                vehicleMakers: action.payload,
            }
        case ActionTypes.GETVEHICLEMAKERBYIDSUCCESS:
            return {
                ...state,
                vehicleMaker: action.payload,
            }
        case ActionTypes.SAVEVEHICLEMAKERSUCCESS:
            return {
                ...state,
                newVehicleMake: action.payload,
            }
        default:
            return state;
    }
}

export default vehicleMakerReducer;